import { defineStore } from "pinia";
import { useLookupStore } from "./LookupStore";

const initialState = {
  tags: [],
  category: null,
  vendor: null,
  type: null,
  color: null,
  onlyNewProduct: false,
}

export const useFilterStore = defineStore('filter', {
  state: () => {
    return {...initialState};
  },

  getters: {
    all() {
      return () => ({...this.$state});
    },
  },

  actions: {
    clear() {
      Object.assign(this, {...initialState});
    },

    reset() {
      const lookupStore = useLookupStore();
      if (!lookupStore.isLoaded) {
        return;
      }

      this.$patch({
        tags: [],
        color: lookupStore.colors[0],
        category: lookupStore.firstCombinedCategoryItem,
        type: lookupStore.types[0],
        vendor: lookupStore.vendors[0],
        onlyNewProduct: false,
      })
    },

    filterByOnlyVendor(vendor) {
      const lookupStore = useLookupStore();
      const vendorToFilter = lookupStore.vendors.find(v => v.id === vendor.id);

      this.$patch({
        tags: [],
        color: lookupStore.colors[0],
        category: lookupStore.firstCombinedCategoryItem,
        type: lookupStore.types[0],
        vendor: vendorToFilter,
        onlyNewProduct: false,
      })
    },
  }
})